import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AiChatRequest, AiChatRequestType } from './ai-chat-request';
import { HttpClient } from '@angular/common/http';
import { AiResponseType } from './endpoint-contracts';

@Injectable({
    providedIn: 'root'
})
export class AiChatRequestService implements AiChatRequest {
    private readonly http = inject(HttpClient);

    public request<Response extends AiResponseType>({ method, url, options }: AiChatRequestType): Observable<Response> {
        return this.http.request<Response>(method, url, options);
    }
}
